import { render, staticRenderFns } from "./TotalPrice.vue?vue&type=template&id=160c035e&"
import script from "./TotalPrice.vue?vue&type=script&lang=js&"
export * from "./TotalPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports